import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'


function DeleteCargoDirectiva(props) {
	const { cargo, mostrar, setQueMostrar, eliminarCargo } = props

	const handleClose = () => {
		setQueMostrar('')
	}
	
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar cargo de la directiva</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Está a punto de eliminar el cargo <strong>{`${cargo.nombre}`}</strong>. Esta acción no se puede deshacer.
				</Alert>
				<p>¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="primary" onClick={() => eliminarCargo(cargo.id)}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default DeleteCargoDirectiva